export const serialize = (value) => {
  try {
    return JSON.stringify(value)
  } catch (e) {
    throw new Error('Value cannot be serialized to JSON')
  }
}

export const deserialize = (value) => {
  try {
    return JSON.parse(value)
  } catch (e) {
    throw new Error('Value is not a JSON string')
  }
}

export const javascriptObjectToEncodedString = (object) => {
  try {
    const string = serialize(object)
    const encodedString = encodeURIComponent(string)
    return encodedString
  } catch (e) {
    throw new Error('Invalid Javascript object')
  }
}
